import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useLocation } from "react-router-dom";
import storiesFooterImg1 from "../../../../assets/image/stories-footer-image-1.png";
import storiesFooterImg2 from "../../../../assets/image/stories-footer-image-2.png";
import rightCarouselIcon from "../../../../assets/image/right-carousel-icon.png";
import {
  fetchStories,
  fetchStoryById,
  getImageUrl,
} from "../../../../api/leads";
import { NewNavbar } from "../../Pages/NewNavbar";
import Footer from "../../Footer";
import Loading from "../../../../components/Loading";
import Loader from "../../Util/Loader";
import FooterStories from "./FooterStories";
import { errorMessage, successMessage } from "../../Util/Toaster";
import { ToastContainer } from "react-toastify";

interface LocalStories {
  id: number;
  title: string;
  subtitle: string;
  websitee: string | null;
  phone: string | null;
  foldername: string;
  isactive: boolean;
  created_at: string;
}

interface Photo {
  id: number;
  localstoriesid: number;
  photo: string;
  isactive: boolean;
  created_at: string;
}

interface Section {
  id: number;
  localstoriesid: number;
  title: string | null;
  paragraph: string;
  isactive: boolean;
  created_at: string;
}

interface Story {
  localstories: LocalStories;
  photo: Photo[];
  // section: section?.[];
  location: any;
}

const FullStory = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isCopied, setIsCopied] = useState(false);
  const [error, setError] = useState(null);
  const stories = useSelector((state: any) => {
    return state?.stories?.data?.data;
  });
  const fullUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchStories());
    };
    fetchData();
  }, [dispatch]);

  const params = useParams()[0];
  // const storyname = params["*"];
  const singleStory = stories?.find(
    (story) => story.localstories.storyname === params
  );

  if (!singleStory) {

    // return <div>Error: Story "{params}" <Loading /> not found.</div>;
    return <Loading />;
  }

  // console.log("singleStory", singleStory);
  const { localstories, photo, section } = singleStory;
  const links = singleStory.localstories.websitee;
  const imageUrls = photo.map((img) =>
    getImageUrl(singleStory.localstories.foldername, img.photo)
  );
  const remainPara = section.slice(3);

  const totalDisplayedParagraphs = Math.min(
    photo.slice(4).length * 2,
    remainPara.length
  );

  console.log('totalDisplayedParagraphs :>> ', totalDisplayedParagraphs);
  console.log('imageUrls :>> ', imageUrls);
  const handleShareClick = async (event) => {
    event.preventDefault();



    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(fullUrl);
        // setIsCopied(true);
        // setError(null);
        if (setIsCopied) {

          successMessage("Copied successfully");
        }
        setTimeout(() => setIsCopied(false), 1500);
      } catch (err) {
        // console.error('Failed to copy URL: ', err);
        errorMessage('Failed to copy. Please copy manually.');
        // setError('Failed to copy. Please copy manually.');
      }
    } else {

      setError('Clipboard API not supported in this browser.');

    }
  };


  return (
    <div>
      <NewNavbar />
      <ToastContainer />
      <section className="magzine-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-12 vs-para">
              <h1 className="main-heading">{localstories.title}</h1>
              <div className="banner-img">
                <img src={imageUrls[0]} alt="" className="img-fluid" />
              </div>
              <div className="center-heading">{localstories.subtitle}</div>

              {/* Render the first two paragraphs */}
              {section.slice(0, 2).map((sec) => (
                <div key={sec.id} className="paraContent">
                  <p>
                    {sec.paragraph.split(/(\*.*?\*)/g).map((part, i) =>
                      part.startsWith('*') && part.endsWith('*')
                        ? <em key={i}>{part.slice(1, -1)}</em>
                        : part
                    )}</p>
                </div>
              ))}

              {/* Render two images after the subtitle and first two paragraphs */}
              <div className="img-container mb-4">
                {imageUrls
                  .slice(2, 4)
                  .map(
                    (imgUrl, index) =>
                      imgUrl && (
                        <img
                          key={index}
                          src={imgUrl}
                          alt=""
                          className="img-fluid"
                        />
                      )
                  )}
              </div>

              {section.slice(2, 3).map((sec) => (
                <div key={sec.id} className="paraContent">
                  <p>
                    {sec.paragraph.split(/(\*.*?\*)/g).map((part, i) =>
                      part.startsWith('*') && part.endsWith('*')
                        ? <em key={i}>{part.slice(1, -1)}</em>
                        : part
                    )}</p>
                </div>
              ))}

              {photo.slice(4).map((element, index) => {
                const firstParaIndex = index * 2;
                const secondParaIndex = firstParaIndex + 1;
                return (
                  <div
                    key={`image-section-${index}`}
                    className={`img-content-wrap-2 ${index % 2 === 0
                      ? "flex-row"
                      : "flex-row-reverse img-content-wrap-1"
                      }`}
                  >
                    <div
                      className="img-container flex-shrink-0"
                      style={{ width: "48%", marginRight: "20px" }}
                    >
                      <img
                        src={getImageUrl(
                          singleStory.localstories.foldername,
                          element.photo
                        )}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="paraContentContainer" style={{ width: "50%" }}>
                      {firstParaIndex < remainPara.length && (
                        <p className="paraContent">


                          {remainPara[firstParaIndex]?.paragraph.split(/(\*.*?\*)/g).map((part, i) =>
                            part.startsWith('*') && part.endsWith('*')
                              ? <em key={i}>{part.slice(1, -1)}</em>
                              : part
                          )}

                        </p>
                      )}
                      {secondParaIndex < remainPara.length && (
                        <p className="paraContent">

                          {remainPara[secondParaIndex]?.paragraph.split(/(\*.*?\*)/g).map((part, i) =>
                            part.startsWith('*') && part.endsWith('*')
                              ? <em key={i}>{part.slice(1, -1)}</em>
                              : part
                          )}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
              {remainPara.slice(totalDisplayedParagraphs).map((para) => (
                <p className="paraContent">{para?.paragraph}</p>
              ))}

              <div className="share-btn-container mt-4">
                {links && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="visit-btn"
                    href={links.startsWith("http") ? links : `https://${links}`}
                  >
                    VISIT
                  </a>
                )}
                <button type="submit" className="share-btn" onClick={handleShareClick} aria-label="Share this page">
                  {isCopied ? 'COPIED!' : 'SHARE'}
                  {error && <span style={{ color: 'red', marginLeft: '10px' }}>{error}</span>}
                </button>
                {/* <a className="share-btn"

                >SHARE</a> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterStories stories={stories} />
      <Footer activeSection="" />
    </div>
  );
};

export default FullStory;
